import { Suspense, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAiAssistant } from '@/contexts/AiAssistantContext';
import { lazyModule } from '@/lib/lazyModule';
import { AiAssistantDock } from './AiAssistantDock';

// Lazy: nothing of the assistant is downloaded until it is opened once.
const AiAssistantWindow = lazyModule(() =>
  import('./AiAssistantWindow').then((m) => ({ default: m.AiAssistantWindow })),
);

export function AiAssistantMount() {
  const { state } = useAiAssistant();
  const { pathname } = useLocation();

  // Fetch and evaluate the chunk while the browser is idle, so the first click
  // does not pay for it: on a throttled phone that was most of a ~750 ms task
  // between the click and a usable panel.
  useEffect(() => {
    const warm = () => void import('./AiAssistantWindow');
    if (typeof requestIdleCallback === 'function') {
      const handle = requestIdleCallback(warm, { timeout: 4000 });
      return () => cancelIdleCallback(handle);
    }
    const timer = window.setTimeout(warm, 2500);
    return () => window.clearTimeout(timer);
  }, []);

  // On the assistant's own page the page *is* the assistant: a second copy
  // would open a second channel subscription over the same conversation.
  if (pathname === '/ai') return null;

  return (
    <>
      {state !== 'closed' && (
        <Suspense fallback={null}>
          <AiAssistantWindow />
        </Suspense>
      )}
      <AiAssistantDock />
    </>
  );
}
